let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("5apdb")]).then(() => parcelRequire('amvLf'));